import "./PatientResources.module.css";
import Header from "@/reusable_sections/Header";
import PreparingForYourVisit from "./sections/PreparingForYourVisit";
import CommonQuestions from "./sections/CommonQuestions";
import Patientengagementcallout from "./sections/Patientengagementcallout";
import Footer from "@/reusable_sections/Footer";
export default function PatientResourcesPage() {
  return <div>
      <Header />
      <PreparingForYourVisit />
      <CommonQuestions />
      <Patientengagementcallout />
      <Footer />
    </div>;
}